import React from "react";

import { requestVisionPlans } from "QuotePage/Actions";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { TitleSmall } from "Cobalt/Header";
import { Modal, ModalBody, ModalHeader } from "Cobalt/Modal";
import { Card } from "Common/Card/";
import { getVisionPlansByCarrier, addPlanToCart } from "Common/CartService";
import { isLoadingVisionPlans } from "Common/CartService/Selectors";
import { LoadingContainer } from "Common/LoadingContainer";

import AncillaryPlanCard from "./AncillaryPlanCard";

import makeBem from "Utils/makeBem";

const bem = makeBem("AddAncillaryPlanModal");

export default function AddVisionModalDumb({ show, onHide, onShow, plans, isLoading, addPlanToCart }) {
  let planItems = (plans || []).map((plan) => <AncillaryPlanCard key={plan.id} plan={plan} addPlanToCart={addPlanToCart} />);

  if (isLoading) {
    planItems = <LoadingContainer />;
  } else if (planItems.length === 0) {
    planItems = (
      <Card theme="elevated" className="plan-card loading">
        <div>We're busy uploading these plans. Please check back later.</div>
      </Card>
    );
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      onShow={() => {
        onShow(plans);
      }}
    >
      <ModalHeader closeButton>
        <TitleSmall mb={0} mt={0}>
          Add Vision
        </TitleSmall>
      </ModalHeader>
      <ModalBody className={bem("body")}>{planItems}</ModalBody>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  plans: getVisionPlansByCarrier(state).filter((plan) => plan.recommended),
  isLoading: isLoadingVisionPlans(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  addPlanToCart: ({ planType, plan }) => {
    AnalyticsTracking.trackEvent("plan_added_to_cart", {
      plan_id: plan.id,
      type: planType,
    });

    AnalyticsTracking.trackEvent("checked_outcart_select_vision", {});

    dispatch(addPlanToCart({ planType, plan }));
    ownProps.onHide();
  },
  onShow: () => {
    dispatch(requestVisionPlans());
  },
});

export const AddVisionModal = connect(mapStateToProps, mapDispatchToProps)(AddVisionModalDumb);
